/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ImageCategory,
  ImageItem,
  ImageMacroCategory,
  Item,
  ProductArea,
  TemplateArea,
  TextItem,
  ZakekeDesigner,
  useZakeke,
} from 'zakeke-configurator-react';
import useStore from '../../Store';
import React, { FC, useEffect, useRef, useState } from 'react';
import Select, { GroupBase, OptionProps, SingleValueProps, components } from 'react-select';
import styled from 'styled-components';
import { Button, ImageItem1, ImagesList } from '../Atomic';
import { useDialogManager } from '../dialogs/Dialogs';
import ErrorDialog from '../dialogs/ErrorDialog';
import ItemText, { EditTextItem } from '../widgets/ItemText';
import {
  Center,
  IconsAndDesignerContainer,
  SelectContainer,
  SubSectionTitle,
  Template,
  TemplatesContainer,
  ZakekeDesignerContainer,
  ZoomInIcon,
  ZoomOutIcon,
} from '../../components/Layout/LayoutStyles';
import ItemImage from '../widgets/ImageItem';
import ItemTextV2 from '../widgets/customText';
import { useTabContext } from './DesignerContext';
import BackWaistItemText from '../widgets/backwaist-ItemText';
import { P, PLACEHOLDERS } from '../../Placeholder';

export type PropChangeHandler = (
  item: EditTextItem, // | EditImageItem,
  prop: string,
  value: string | boolean | File
) => void;

export interface TranslatedTemplate {
  id: number;
  name: string;
}

const ZoomIconIn = styled(ZoomInIcon)`
  left: 0px;
`;
const ZoomIconOut = styled(ZoomOutIcon)`
  left: 0px;
`;

const DesignerContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-flow: column;
  user-select: none;
  width: 100%;
  position: relative;
  // bottom: 1.5em;
`;

const UploadButtons = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 5px;
  margin: 20px 0px;
`;

const Area = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: left;
  min-height: 47px;
  min-width: 70px;
  border-bottom: 5px solid transparent;
  cursor: pointer;
  padding: 0px 5px;
  text-align: center;

  &:hover {
    border-bottom: 5px solid #c4c4c4;
  }

  ${(props) =>
    props.selected &&
    `
       border-bottom: 5px solid #c4c4c4;
    `}
`;

const OptionContainer = styled(components.Option)`
  background-color: white !important;
  span {
    color: black;
  }
  &:hover {
    background-color: #ddd !important;
  }
`;

const SingleValueContainer = styled(components.SingleValue)`
  span {
    color: black;
  }
`;

const CopyrightMessage = styled.div`
  display: flex;
  flex-direction: column;
`;

const CopyrightMandatoryMessageContainer = styled.div`
  display: grid;
  grid-template-columns: 20px auto;
  grid-gap: 5px;
`;

const CopyrightCheckbox = styled.input`
  width: 13px;
`;

const CopyrightMandatoryMessage = styled.div``;

const Designer: FC<{
  onCloseClick?: () => void;
  TextWaistbandController?: (isAdd: boolean) => void;
  placeholder?: string;
  onPriceChange?: (price?: any) => void;
  setCustomizeTab?: (value: boolean) => void;
  setAreaId?: (value: number) => void;
  waistbandTextColor?: string;
  waistbandTextColorBack?: string;
}> = ({
  onCloseClick,
  placeholder,
  setCustomizeTab,
  onPriceChange,
  waistbandTextColor,
  TextWaistbandController,
  setAreaId,
  waistbandTextColorBack,
}) => {
  const { showDialog, closeDialog } = useDialogManager();
  const [forceUpdate, setForceUpdate] = useState(false);
  const { setIsLoading, isMobile } = useStore();

  const {
    currentTemplate,
    items,
    isAreaVisible,
    product,
    templates,
    setTemplate,
    setCamera,
    removeItem,
    setItemImageFromFile,
    setItemImage,
    setItemText,
    setItemItalic,
    setItemBold,
    setItemColor,
    setItemFontFamily,
    setItemTextOnPath,
    addItemText,
    addItemImage,
    createImage,
    // getTemplateUploadRestrictictions,
    eventMessages,
    setCopyrightMessageAccepted,
    getCopyrightMessageAccepted,
    fonts,
    getPrintingMethodsRestrictions,
    setItemConstraints,
    setItemSize,
    getPrintingMethods,
    setPrintingMethod,
  } = useZakeke();

  const customizerRef = useRef<any | null>(null);
  const [selectedCarouselSlide, setSelectedCarouselSlide] = useState<number>(0);

  const filteredAreas = product?.areas.filter((area) => isAreaVisible(area.id)) ?? [];
  let finalVisibleAreas: ProductArea[] = [];

  const [moveElements, setMoveElements] = useState(false);

  let translatedTemplates = templates.map((template) => {
    return { id: template.id, name: template.name, areas: template.areas };
  });
  let translatedCurrentTemplate = {
    id: currentTemplate?.id,
    name: currentTemplate?.name,
    areas: currentTemplate?.areas,
  };
  let translatedAreas = filteredAreas.map((area) => {
    return { id: area.id, name: area.name };
  });

  filteredAreas.length > 0 &&
    filteredAreas.forEach((filteredArea) => {
      let currentTemplateArea = currentTemplate!.areas.find((x) => x.id === filteredArea.id);
      let itemsOfTheArea = items.filter((item) => item.areaId === filteredArea.id);

      const areAllItemsStatic = !itemsOfTheArea.some((item) => {
        return (
          !item.constraints ||
          item.constraints.canMove ||
          item.constraints.canRotate ||
          item.constraints.canResize ||
          item.constraints.canEdit
        );
      });
      if (
        !areAllItemsStatic ||
        !currentTemplateArea ||
        currentTemplateArea?.canAddImage ||
        currentTemplateArea?.canAddText
      )
        finalVisibleAreas.push(filteredArea);
    });

  const [actualAreaId, setActualAreaId] = useState<number>(
    finalVisibleAreas && finalVisibleAreas.length > 0 ? finalVisibleAreas[0].id : 0
  );

  let currentTemplateArea = currentTemplate!.areas.find((x) => x.id === actualAreaId);
  let itemsFiltered = items.filter((item) => item.areaId === actualAreaId);
  const allStaticElements = !itemsFiltered.some((item) => {
    return (
      !item.constraints ||
      item.constraints.canMove ||
      item.constraints.canRotate ||
      item.constraints.canResize
    );
  });
  const showAddTextButton = !currentTemplateArea || currentTemplateArea.canAddText;
  const showUploadButton =
    !currentTemplateArea ||
    (currentTemplateArea.canAddImage && currentTemplateArea.uploadRestrictions.isUserImageAllowed);
  const showGalleryButton =
    !currentTemplateArea ||
    (currentTemplateArea.canAddImage && !currentTemplateArea.disableSellerImages);

  const supportedFileFormats = getSupportedUploadFileFormats(
    currentTemplate!.id,
    actualAreaId
  ).join(', ');

  const [copyrightMandatoryCheckbox, setCopyrightMandatoryCheckbox] = useState(
    getCopyrightMessageAccepted()
  );
  const copyrightMessage = eventMessages && eventMessages.find((message) => message.eventID === 8);

  const slidesToShow = window.innerWidth <= 1600 ? 3 : 4;

  const setTemplateByID = async (templateID: number) => await setTemplate(templateID);

  useEffect(() => {
    if (templates.length > 0 && !currentTemplate) setTemplateByID(templates[0].id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templates]);

  useEffect(() => {
    if (finalVisibleAreas.length > 0 && actualAreaId === 0)
      setActualAreaId(finalVisibleAreas[0].id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalVisibleAreas]);

  function getSupportedUploadFileFormats(templateId: number, areaId: number) {
    const fileFormats: string[] = ['.jpg', '.jpeg', '.png', '.svg', '.eps', '.pdf'];
    return fileFormats;
  }

  const isItemEditable = (item: Item, templateArea?: TemplateArea) => {
    if (!item.constraints) return false;

    let {
      canEdit,
      canMove,
      canRotate,
      canResize,
      canDelete,
      canChangeFontColor,
      canChangeFontFamily,
      canChangeFontWeight,
      isPrintable,
    } = item.constraints;

    if (!isPrintable) return false;

    let common = canEdit || canMove || canRotate || canResize || canDelete;
    let text = canChangeFontColor || canChangeFontFamily || canChangeFontWeight;
    let image =
      canEdit ||
      (templateArea &&
        (templateArea.uploadRestrictions.isUserImageAllowed || !templateArea.disableSellerImages));

    if (item.type === 0) return common || text;
    else return common || image;
  };

  interface Image {
    imageID: number;
    name: string;
    choiceUrl: string;
    preferredWidth: number | null;
    preferredHeight: number | null;
  }

  const { getMacroCategories, getImages } = useZakeke();
  const [isLoading, setIsloading] = useState(false);
  const [isClipArt, setClipArt] = useState(false);
  const [isDesign, setDesign] = useState(false);
  const [macroCategories, setMacroCategories] = useState<ImageMacroCategory[]>([]);
  const [selectedMacroCategory, setSelectedMacroCategory] = useState<ImageMacroCategory | null>(
    null
  );
  const [selectedCategory, setSelectedCategory] = useState<ImageCategory | null>();
  const [images, setImages] = useState<Image[]>();
  const [selectedImageIds, setSelectedImageIds] = useState<number[]>([]);
  const [activeButton, setActiveButton] = useState<string | null>(null);
  const [categories, setCategories] = useState<ImageCategory[]>([]);

  const removeItemsInArea = (
    areaId: number,
    placeholder: string,
    typeToRemove: 'Text' | 'Image'
  ) => {
    const allowedAreasPlaceholders = [PLACEHOLDERS.FrontAreaKeyword, PLACEHOLDERS.BackAreaKeyword];
    if (!allowedAreasPlaceholders.includes(placeholder)) return;

    items
      .filter((item) => item.areaId === areaId)
      .forEach((item) => {
        if (
          (typeToRemove === 'Text' && item.type === 0) ||
          (typeToRemove === 'Image' && item.type === 1)
        ) {
          removeItem(item.guid);
        }
      });
  };

  useEffect(() => {
    setSelectedImageIds([]);
    setActiveButton(null);
  }, [actualAreaId]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setIsLoading(true);
        const macroCategories = await getMacroCategories();
        const allCategories = macroCategories.flatMap((macro) => macro.categories);
        setCategories(
          allCategories.filter(
            (cat: { name: string }) =>
              !['gray print areas', 'print area'].includes(cat.name.trim().toLowerCase())
          )
        );

        setIsLoading(false);

        if (allCategories.length > 0) {
          handleCategoryClick(allCategories[2]);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchCategories();
  }, []);

  const updateCategories = async () => {
    try {
      setIsloading(true);
      let macroCategories = await getMacroCategories();
      setIsloading(false);
      setMacroCategories(macroCategories);
      handleMacroCategoryClick(macroCategories[0]);
    } catch (ex) {
      console.error(ex);
    }
  };

  const handleMacroCategoryClick = async (macroCategory: ImageMacroCategory) => {
    setSelectedMacroCategory(macroCategory);
    setCategories(
      macroCategory.categories.filter((cat: { name: string }) => cat.name !== 'Gray print areas ')
    );

    console.log(categories);

    handleCategoryClick(macroCategory.categories[1]);
  };
  const handleCategoryClick = async (category: ImageCategory) => {
    try {
      setSelectedImageIds([]);
      setSelectedCategory(category);
      setIsLoading(true);
      const images = await getImages(category.categoryID!);
      setImages(images);
      setIsLoading(false);
    } catch (ex) {
      console.error(ex);
    }
  };

  const handleAddClipArt = async (image: Image) => {
    if (placeholder) {
      removeItemsInArea(actualAreaId, placeholder, 'Image');
      removeItemsInArea(actualAreaId, placeholder, 'Text');
      const area = finalVisibleAreas.find((area) => P.contains(area.name, placeholder));
      // console.log(area)
      if (area) {
        setCamera(area.cameraLocationID as string);
      }
    }

    setSelectedImageIds((prev) => {
      if (prev.includes(image.imageID)) {
        return prev.filter((id) => id !== image.imageID);
      } else {
        return [...prev, image.imageID];
      }
    });

    setActiveButton('pattern');
    closeDialog('add-image');

    try {
      const guid = await addItemImage(image.imageID, actualAreaId);
      if (!guid) return;
      if (
        !P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) &&
        !P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)
      ) {
        await setItemSize(guid, 3, 3);
      } else {
        await setItemSize(guid, 5, 5);
      }
      await setItemConstraints(guid, {
        canResize: false,
      });
    } catch (error) {
      console.error('Error adding and configuring clipart:', error);
    }
  };

  const printingMethods = getPrintingMethods();
  // console.log('-----p', printingMethods)

  const handleAddTextClick = async () => {
    if (placeholder) {
      removeItemsInArea(actualAreaId, placeholder, 'Image');
      const area = finalVisibleAreas.find((area) => P.contains(area.name, placeholder));
      // console.log(area)
      if (area) {
        setCamera(area.cameraLocationID as string);
      }
    }

    let method;

    if (
      P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) ||
      P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)
    ) {
      setCustomizeTab?.(true);

      method = printingMethods.find((pm) => pm.name.toLowerCase().includes('waistband text print'));
    } else {
      method = printingMethods.find((pm) =>
        pm.name.toLowerCase().includes('test shorts print type')
      );
    }

    // console.log(method); // Now this will work

    if (method) {
      await setPrintingMethod(method.printMethodId, actualAreaId);
    }

    const defaultItem: EditTextItem = {
      guid: '',
      name: '',
      text: 'Text',
      fillColor: '#2A2B2C',
      fontFamily: fonts[0]?.name,
      fontSize: 500,
      fontWeight: 'normal normal',
      isTextOnPath: false,
      constraints: null,
    };

    // Directly add item without showing the dialog
    addItemText(defaultItem, actualAreaId);
  };

  const handleUploadImageClick = async () => {
    if (!currentTemplate || !actualAreaId) return;

    const fileFormats = getSupportedUploadFileFormats(currentTemplate.id, actualAreaId);

    const existingInput = document.getElementById('upload-image-input');
    if (existingInput) existingInput.remove();

    const input = document.createElement('input');
    input.setAttribute('id', 'upload-image-input');
    input.setAttribute('accept', fileFormats.join(','));
    input.setAttribute('type', 'file');

    input.addEventListener('change', async (e) => {
      const files = (e.currentTarget as HTMLInputElement).files;
      if (!files || files.length === 0) return;

      setIsLoading(true);
      try {
        if (placeholder) {
          await removeItemsInArea(actualAreaId, placeholder, 'Image');
          removeItemsInArea(actualAreaId, placeholder, 'Text');
          const area = finalVisibleAreas.find((area) => P.contains(area.name, placeholder));
          if (area) {
            setCamera(area.cameraLocationID as string);
          }
        }

        const image = await createImage(files[0], (progress) =>
          console.log(`Progress: ${progress}%`)
        );

        const guid = await addItemImage(image.imageID, actualAreaId);
        if (!guid) return;
        if (
          !P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) &&
          !P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)
        ) {
          await setItemSize(guid, 3, 3);
        } else {
          await setItemSize(guid, 5, 5);
        }
        await setItemConstraints(guid, {
          canResize: false,
        });
      } catch (error) {
        console.error(error);
        showDialog(
          'error',
          <ErrorDialog error="Failed uploading image." onCloseClick={() => closeDialog('error')} />
        );
      } finally {
        setIsLoading(false);
        input.remove();
      }
    });

    document.body.appendChild(input);
    input.click();
  };

  const handleItemRemoved = (guid: string) => {
    removeItem(guid);
  };

  const prices = {
    TEXT: 8,
    GRAPHICS: 10,
    UPLOAD: 25,
  };

  const handleItemPropChange = (
    item: EditTextItem,
    prop: string,
    value: string | boolean | File
  ) => {
    switch (prop) {
      case 'remove':
        handleItemRemoved(item.guid);
        break;
      case 'text':
        setItemText(item.guid, value as string);
        break;
      case 'font-italic':
        setItemItalic(item.guid, value as boolean);
        break;
      case 'font-bold':
        setItemBold(item.guid, value as boolean);
        break;
      case 'font-color':
        setItemColor(item.guid, value as string);
        break;
      case 'font-family':
        setItemFontFamily(item.guid, value as string);
        break;
      case 'text-path':
        setItemTextOnPath(item.guid, actualAreaId, value as boolean);
        setTimeout(() => setForceUpdate(!forceUpdate), 100);
        break;
    }
  };

  const SelectOption = (
    props: JSX.IntrinsicAttributes & OptionProps<any, boolean, GroupBase<any>>
  ) => {
    return <OptionContainer {...props}>{<span>{props.data.name}</span>}</OptionContainer>;
  };

  const SelectSingleValue = (
    props: JSX.IntrinsicAttributes & SingleValueProps<any, boolean, GroupBase<any>>
  ) => {
    return <SingleValueContainer {...props}>{<span>{props.data.name}</span>}</SingleValueContainer>;
  };
  const { areaStates, setActiveTab, addUploadedImage } = useTabContext();
  const state = areaStates[placeholder!] || { activeTab: 'TEXT', uploadedImages: [] };
  const activeTab = state.activeTab;

  const tabStyle = (tab: string): React.CSSProperties => ({
    padding: '10px 5px',
    justifyContent: 'space-evenly',
    borderBottom: activeTab === tab ? '2px solid black' : 'none',
    fontWeight: activeTab === tab ? '700' : '400',
    cursor: 'pointer',
    gap: '7px',
    display: 'flex',
    fontSize: '14px',
    color: '#000000',
  });

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
  };

  useEffect(() => {
    console.log('placeholder:', placeholder);
    console.log(
      'finalVisibleAreas:',
      finalVisibleAreas.map((a) => a.name)
    );
    const area = finalVisibleAreas.find((area) => P.contains(area.name, placeholder!));
    console.log('matched area:', area);
    // console.log(area)
    if (area) {
      setActualAreaId(area.id);
      setAreaId?.(area.id);
      setCamera(area.cameraLocationID as string);
    }
  }, []);

  return (
    <>
      {/* <div className="menu_help_customization_help">Your name or initials will be applied on your blazers inner pocket.</div> */}
      {!moveElements && (
        <DesignerContainer isMobile={isMobile}>
          {!isMobile && templates.length > 1 && (
            <TemplatesContainer>
              {templates.map((template) => (
                <Template
                  key={template.id}
                  selected={currentTemplate === template}
                  onClick={async () => {
                    await setTemplate(template.id);
                  }}
                >
                  {template.name}
                </Template>
              ))}
            </TemplatesContainer>
          )}

          {isMobile && translatedTemplates.length > 1 && (
            <SelectContainer>
              <span>{'Templates'}</span>
              <Select
                styles={{
                  container: (base) => ({
                    ...base,
                    minWidth: 300,
                  }),
                }}
                isSearchable={false}
                options={translatedTemplates}
                menuPosition="fixed"
                components={{
                  Option: SelectOption,
                  SingleValue: SelectSingleValue,
                }}
                value={translatedTemplates!.find((x) => x.id === translatedCurrentTemplate.id)}
                onChange={async (template: any) => await setTemplate(template.id)}
              />
            </SelectContainer>
          )}

          {itemsFiltered.length === 0 &&
            !(showAddTextButton || showUploadButton || showGalleryButton) && (
              <Center>{'No customizable items'}</Center>
            )}

          <>
            <br></br>

            <div style={containerStyle}>
              <div
                className={`tab ${activeTab === 'TEXT' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(placeholder!, 'TEXT');
                  setCustomizeTab?.(false);
                  onPriceChange?.(prices.TEXT);
                  placeholder && removeItemsInArea(actualAreaId, placeholder, 'Image');
                  TextWaistbandController?.(true);
                }}
              >
                TEXT{' '}
                {!P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) &&
                !P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)
                  ? '(+£8)'
                  : '(+£10)'}
              </div>
              <div
                className={`tab ${activeTab === 'GRAPHICS' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(placeholder!, 'GRAPHICS');
                  setCustomizeTab?.(false);
                  onPriceChange?.(prices.GRAPHICS);
                  placeholder && removeItemsInArea(actualAreaId, placeholder, 'Text');
                  placeholder && removeItemsInArea(actualAreaId, placeholder, 'Image');
                  TextWaistbandController?.(true);
                }}
              >
                GRAPHICS (+£10)
              </div>

              <div
                className={`tab ${activeTab === 'UPLOAD' ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(placeholder!, 'UPLOAD');
                  setCustomizeTab?.(false);
                  onPriceChange?.(prices.UPLOAD);
                  placeholder && removeItemsInArea(actualAreaId, placeholder, 'Text');
                  placeholder && removeItemsInArea(actualAreaId, placeholder, 'Image');
                  TextWaistbandController?.(true);
                }}
              >
                UPLOAD (+£25)
              </div>
            </div>
          </>

          {activeTab === 'TEXT' &&
            itemsFiltered.map((item) => {
              if (item.type === 0 && isItemEditable(item, currentTemplateArea))
                return P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword) ? (
                  <BackWaistItemText
                    placeholder={placeholder}
                    key={item.guid}
                    waistbandTextColor={waistbandTextColorBack}
                    handleItemPropChange={handleItemPropChange}
                    item={item as TextItem}
                    TextWaistbandController={TextWaistbandController}
                  />
                ) : (
                  <ItemText
                    placeholder={placeholder}
                    key={item.guid}
                    waistbandTextColor={waistbandTextColor}
                    handleItemPropChange={handleItemPropChange}
                    item={item as TextItem}
                    TextWaistbandController={TextWaistbandController}
                  />
                );

              return null;
            })}

          {activeTab === 'GRAPHICS' && showGalleryButton && selectedCategory && images && (
            <>
              <div className="">
                <span className="badges-header">
                  <SubSectionTitle>
                    <strong>COLLECTION: </strong>
                    BADGES
                  </SubSectionTitle>
                  <span className="badges-note">
                    <strong>Note</strong> Graphic Size will not be more than 10cm{' '}
                  </span>
                </span>
                <div className="badges-select-wrapper">
                  <select
                    className="badges-select"
                    value={selectedCategory?.categoryID?.toString() ?? ''}
                    onChange={(e) => {
                      const selectedId = Number(e.target.value);
                      const cat = categories.find((c) => c.categoryID === selectedId);
                      if (cat) handleCategoryClick(cat);
                    }}
                  >
                    {categories.map((cat) => (
                      <option key={cat.categoryID} value={cat.categoryID?.toString()}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {isLoading ? (
                <p>Loading...</p>
              ) : (
                <ImagesList>
                  {images.map((image) => (
                    <ImageItem1
                      isActive={selectedImageIds.includes(image.imageID)}
                      key={image.imageID.toString()}
                      onClick={() => handleAddClipArt(image)}
                    >
                      <img src={image.choiceUrl} alt={image.name} />
                    </ImageItem1>
                  ))}
                </ImagesList>
              )}

              {(P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) ||
                P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)) &&
                itemsFiltered.map((item) => {
                  if (item.type === 1 && isItemEditable(item, currentTemplateArea))
                    return (
                      <ItemImage
                        uploadImgDisabled={
                          copyrightMessage && copyrightMessage.additionalData.enabled
                            ? !copyrightMandatoryCheckbox
                            : false
                        }
                        key={item.guid}
                        handleItemPropChange={handleItemPropChange}
                        item={item as ImageItem}
                        currentTemplateArea={currentTemplateArea!}
                      />
                    );
                  return null;
                })}
            </>
          )}

          {activeTab === 'UPLOAD' && (
            <div>
              <span className="note-text">
                <strong>Note</strong> Photo Size will not be more than 10cm
              </span>

              <div className="upload-artwork-btn" onClick={handleUploadImageClick}>
                UPLOAD YOUR ARTWORK
              </div>

              {(P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) ||
                P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)) &&
                itemsFiltered.map((item) => {
                  if (item.type === 1 && isItemEditable(item, currentTemplateArea))
                    return (
                      <ItemImage
                        uploadImgDisabled={
                          copyrightMessage && copyrightMessage.additionalData.enabled
                            ? !copyrightMandatoryCheckbox
                            : false
                        }
                        key={item.guid}
                        handleItemPropChange={handleItemPropChange}
                        item={item as ImageItem}
                        currentTemplateArea={currentTemplateArea!}
                      />
                    );
                  return null;
                })}
            </div>
          )}

          <div className="move_element">
            {/* <div > */}
            {activeTab === 'TEXT' &&
              ((!P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) &&
                !P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword)) ||
                ([PLACEHOLDERS.FrontAreaKeyword, PLACEHOLDERS.BackAreaKeyword].includes(
                  placeholder!
                ) &&
                  itemsFiltered.filter((item) => item.type === 0).length < 1)) && (
                <button className="my-button" onClick={() => handleAddTextClick()}>
                  <span>
                    {itemsFiltered.filter((item) => item.type === 0).length === 0
                      ? 'Add New Text'
                      : 'Add More Text'}
                  </span>
                </button>
              )}
            {/* </div> */}
            <div className="design-flex">
              {itemsFiltered.length > 0 && !allStaticElements && (
                <button className="my-button" onClick={() => setMoveElements(true)}>
                  <span>{'Change Embroidery Position'} </span>
                </button>
              )}
            </div>
          </div>
          {!P.equals(placeholder!, PLACEHOLDERS.FrontAreaKeyword) &&
            !P.equals(placeholder!, PLACEHOLDERS.BackAreaKeyword) &&
            itemsFiltered.length > 0 &&
            !allStaticElements && (
              <>
                <div className="designer-subheading">
                  <SubSectionTitle>
                    <strong>SELECTED ELEMENTS</strong>
                  </SubSectionTitle>
                  {itemsFiltered.map((item) => {
                    if (item.type === 0 && isItemEditable(item, currentTemplateArea)) {
                      return (
                        <ItemTextV2
                          placeholder={placeholder}
                          key={item.guid}
                          handleItemPropChange={handleItemPropChange}
                          item={item as TextItem}
                        />
                      );
                    }

                    if (item.type === 1 && isItemEditable(item, currentTemplateArea)) {
                      return (
                        <ItemImage
                          uploadImgDisabled={
                            copyrightMessage && copyrightMessage.additionalData.enabled
                              ? !copyrightMandatoryCheckbox
                              : false
                          }
                          key={item.guid}
                          handleItemPropChange={handleItemPropChange}
                          item={item as ImageItem}
                          currentTemplateArea={currentTemplateArea!}
                        />
                      );
                    }
                    return null;
                  })}
                </div>
              </>
            )}
        </DesignerContainer>
      )}
      <br />
      <br />

      {moveElements && (
        <>
          <ZakekeDesignerContainer isMobile={isMobile} className="zakeke-container">
            <div className="designer-wrapper">
              <ZakekeDesigner ref={customizerRef} areaId={actualAreaId} />
              <IconsAndDesignerContainer></IconsAndDesignerContainer>
            </div>
          </ZakekeDesignerContainer>
          <div className="button-wrapper">
            <button className="my-button" onClick={() => setMoveElements(false)}>
              <span>OK</span>
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default Designer;
